import { Notificationn } from '../../home/home.model';
export class RecentPicture {
  id: string;
  thumbnailUrl: string;
  url: string;
  createdTime: Date;
}

export class MemberConnection {
  id: string;
  name: string;
}

export class WorkHistory {
  id: string;
  name: string;
  startDate?: Date;
  endDate?: Date;
}

export class EducationHistory {
  id: string;
  name: string;
  graduationYear?: number;
  type: string;
}

export class CheckIn {
  id: string;
  name: string;
  time: Date;
}

export class Event {
  id: string;
  name: string;
  location: string;
  startTime: Date;
  endTime?: Date;
}

export class PageLike {
  id: string;
  pageName: string;
}

export class FbDataModel {
  id: string;
  name: string;
  email: string;
  ageRange: string;
  gender: string;
  // currentCity?: any;
  profilePictureUrl: string;
  coverPictureUrl: string;
  profileUrl: string;
  // recentPictures: RecentPicture[];
  friendsCount: number;
  memberConnections?: MemberConnection[];
  workHistory: WorkHistory[];
  // educationHistory: EducationHistory[];
  // checkIns: CheckIn[];
  // events: Event[];
  // pageLikes: PageLike[];
}


export class MemberProfileInfoModel {
  name: string;
  email: string;
  workEmail: string;
  registrationEmail: string;
  registrationDate?: Date;
  acceptanceDate?: Date;
  doB: Date;
  invitedByFullName?: any;
  isPayingMember: boolean;
  invitedById: number;
  memberFavourites: string;
  industry: string;
  employerOrUniversity: string;
  jobRole: string;
  membershipNumber: number;
  membershipType: string;
  // What they applied for, which is a historical record and does not follow a later upgrade.
  // membershipType above is what they hold now; the two can legitimately differ.
  appliedMembershipTypeString: string;
  expiryDate: Date;
  canCreatePremiumInvitationCodes: boolean;
  standardInvitationsLeft: number;
  premiumInvitationsLeft: number;
  standardInvitationsUsed: number;
  premiumInvitationsUsed: number;
  isActive: boolean;
  venueActivity: Array<MemberDetailsVenueActivityResponseModel>;
  notifications: Notificationn[];
  subscriptionHistory: SubscriptionHistoryItemModel[];
  image: string;
  hasFacebook: boolean;
  linkedIn: string;
  twitter: string;
  website: string;
  instagram: string;
  screenshot: string;
  lastLogin: Date;
  statusHistory: StatusHistory[];
}
export class MemberDetailsVenueActivityResponseModel {
  public timeOfVisit: Date;
  public venueName: string;
  public partySize: number;
  public revenue: number;
}

export class SubscriptionHistoryItemModel {
  public paymentTime: Date;
  public amount: number;
}

export class InvitationCodesInfoModel {
  dateCreated: Date;
  memeberName: string;
  isPremium: boolean;
  isAdmin: boolean;
}

export class MemberUpdateRequestModel {
  memberId: number;
  name: string;
  email: string;
  workEmail: string;
  membershipType: string;
  expiryDate?: string;
  expiryPeriod?: string;
  standardInvitations?: number;
  premiumInvitations?: number;
  canCreatePremiumInvitationCodes: boolean;
  updateExpirationDate: boolean;
  firstName?: string;
  lastName?: string;
}

export class StatusHistory {
  actionDate: Date;
  status: string;
  user: string;
  // "Payment Pending", or absent. The API sets it on the latest Accepted row only.
  paymentStatus?: string;
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/members/member-management/member-info.model.ts